import fr from 'facet-rest';
import { BaseOverrideNoHidden } from 'Views/Page/Content/Templates/BaseOverride';
import { CheckboxInputLarge } from 'Packages/FacetDesign/Components/CheckboxInput';
import { overrideReadOnly } from 'Packages/FacetRest/FacetDesignOverride';
import { FDStat } from '@facet-wealth/design';

export default fr.metaOverride({ base: BaseOverrideNoHidden })
  .override({ name: 'createOnActivation' }, {
    _component: () => CheckboxInputLarge,
  }, {
    ordinal: 300,
  })
  .nameOverride(['allocation', 'accountsAllocation'], {
    _component: () => FDStat,
  }, overrideReadOnly);
